export default __webpack_public_path__ + "static/poele-a-bois-56dad39adbd31d8d5bccedaf40e81c7f.jpg";